import { moveAxisRange, rotateAxisRange, moveAxis } from '../../../utils/moveObjects'
import { useFrame } from "@react-three/fiber"
import { useEffect, useRef } from "react"
import { useActsStore } from "../../../store/useActsStore"
import { CylinderMaterial } from "./CylinderMaterial"



export default function Cockpit(props) {
    const cockpit = useRef()
    const cockpitReflect = useRef()
    const mat = useRef()

    const cockPitStartPosition = [0, 0.5, 0]
    // const cockPitStartPosition = [1, -2, 9]
    const uTimeRef = useRef(0)

    useFrame(() => {
        const stateActe = useActsStore.getState()
        const id = stateActe.getCurrentActId()
        const holdProgress = stateActe.actsProgress[id]?.holdProgress ?? 0
    })

    return <>
        <group position={cockPitStartPosition} rotation={[0, Math.PI * 0.5, Math.PI * 0.5]} scale={2.5}>
            <mesh
                {...props}
                
                castShadow
                ref={cockpitReflect}
            >
                <sphereGeometry args={[0.03, 32, 32]} />
                <CylinderMaterial />
            </mesh>

            <mesh
                {...props}
                
                castShadow
                ref={cockpit}
            >
                <sphereGeometry args={[0.031, 32, 32]} />
                <meshPhysicalMaterial
                    roughness={0.1}
                    metalness={0.2}
                    thickness={0}
                    transmission={0.9}
                    attenuationDistance={0.45}
                    ior={1}
                    clearcoat={0}
                    dispersion={0}
                />
            </mesh>
        </group>

    </>
}